import { Outlet } from 'react-router-dom';
import { paths } from 'core/routing/paths';
import { AppShell, BrandLink, ShellMain } from 'layout/AppShell';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';

export function SystemLayout() {
  return (
    <AppShell className="system-shell" compactFooter>
      <header className="site-header">
        <div className="shell-container header-inner">
          <BrandLink to={paths.welcome} />
          <LanguageSwitcher />
        </div>
      </header>
      <ShellMain className="system-main">
        <div className="shell-container">
          <Outlet />
        </div>
      </ShellMain>
    </AppShell>
  );
}
